<ng-content></ng-content>
<tp-icon
  *ngIf="input?.value"
  class="show-hide-password__icon"
  [name]="isHidden ? 'icons/hide-password' : 'icons/show-password'"
  (click)="toggle()"
></tp-icon>
